import {createAction} from "redux-act";
import {IVote} from "apps/BUDWEISERPOTM/modules/actions";

export const openVoteConfirmationModal = createAction<number>();
export const closeVoteConfirmationModal = createAction();

export interface ITermsModalPayload {
	data: IVote;
}

export const openBudweiserTermsModal = createAction<ITermsModalPayload>();
export const closeBudweiserTermsModal = createAction();
